import React, {forwardRef, useImperativeHandle, useReducer} from 'react'
import {Alert, Card, Colors, H6, Link, Modal, ModalHeader, P, Row, S1, S2, ScrollView} from '../UI/index.js'
import usePackageStore from '../../stores/PackageStore.js'
import dbCodes from '../../../server/dbCodes.js'
import moment from 'moment'

/**
 * @typedef {import('../../../types/types.js').Packaging} Packaging
 */

/**
 * @typedef {object} ViewPackagingModalProps
 *
 * @param {{}} history
 * @param {function} [onClose]
 */

const ViewPackagingModal = forwardRef(

    /**
 * @component
 *
 * @param {ViewPackagingModalProps} props
 *
 * @returns {JSX.Element}
 */
    ({history, onClose}, ref) => {
    /**
     * @type {[{packaging: Packaging | null, show: boolean, loading: boolean, error: string | null}, function: (newState: {packaging?: Packaging | null, show? : boolean, loading?: boolean, error?: string | null}) => void]}
     */
        const [state, setState] = useReducer((state, newState) => ({...state, ...newState}), {
            packaging: null,
            show: false,
            loading: false,
            error: null
        })
        const PackageStore = usePackageStore()

        const open = (id) => {
            setState({show: true, loading: true})

            PackageStore.getOne(id, (err, packaging) => {
                if (err) {
                    console.error(err)
                    return
                }

                console.log(packaging)

                setState({packaging, loading: false})
            })
        }

        const close = () => {
            setState({packaging: null, show: false, loading: false, error: null})
            onClose && onClose()
        }

        // To make passed functions accessible to parents
        useImperativeHandle(ref, () => ({open, close}))

        const {packaging, show, loading, error} = state

        return (
            <Modal show={show} onClose={close} style={{maxWidth: 600}}>
                <ModalHeader title='Emballage' onClose={close} style={{alignItems: 'baseline'}} />

                {loading &&
                    <Row>
                        <H6 style={{marginBottom: 12}}>Loading...</H6>
                    </Row>
                }

                {error &&
                    <Alert variant='error' style={{marginBottom: 24}}>{error}</Alert>
                }

                {packaging &&
                    <>
                        <Card style={{marginBottom: 24}}>
                            <Row style={{alignItems: 'center'}}>
                                <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                                    <i style={{fontSize: 16, marginRight: 12}} className='mdi mdi-package-variant-closed' />
                                    <P>{packaging.barcode}</P>
                                </Row>

                                <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', background: Colors.grey20, height: 42, marginLeft: 6, marginRight: 6, marginBottom: 6}}>
                                        <S1>{dbCodes.packagingStatus[packaging.status]}</S1>
                                    </div>
                                </Row>
                            </Row>
                        </Card>

                        <H6 style={{marginBottom: 12}}>Historie</H6>

                        <ScrollView style={{maxHeight: 250}}>
                            {[...packaging.events].reverse().map((event, index) => {
                                return (
                                    <Row key={`history${index}`} style={{marginBottom: 3, flexShrink: 0}}>

                                        <i className='mdi mdi-circle-small' style={{marginRight: 6, fontSize: 16, color: Colors.grey60}} />

                                        <Row style={{paddingLeft: 6, paddingRight: 6, flex: 1, flexDirection: 'column', minWidth: 'auto'}}>

                                            <Row style={{alignItems: 'center'}}>
                                                {event.orderId ?
                                                    <Link onClick={() => history.push(`/planning?orderId=${event.orderId}`)}>{event.description || dbCodes.packagingStatus[event.status]}</Link> :
                                                    <P>{event.description || dbCodes.packagingStatus[event.status]}</P>
                                                }
                                            </Row>
                                        </Row>

                                        <Row style={{paddingLeft: 6, paddingRight: 6, width: 200, minWidth: 'auto'}}>
                                            <S2>{`${event.who || ''} | ${moment(event.timestamp).format('DD-MM-YYYY HH:mm:ss')}`}</S2>
                                        </Row>
                                    </Row>
                                )
                            })}
                        </ScrollView>
                    </>
                }

            </Modal>
        )
    })

ViewPackagingModal.displayName = 'ViewPackagingModal'

export default ViewPackagingModal
